<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
            <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sStartTime">From (yyyy/mm/dd 00:00:00) From</label>
                  <b-input id="sStartTime" type="date" placeholder="" v-model.trim="sStartTime"></b-input>
                  <div v-if="$v.sStartTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sStartTime.required">Select Start Time</div>
                  </div>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sEndTime">To (yyyy/mm/dd 23:59:59) To</label>
                  <b-input id="sEndTime" type="date" placeholder="" v-model.trim="sEndTime"></b-input>
                  <div v-if="$v.sEndTime.$error">
                    <div class="invalid-feedback d-block" v-if="!$v.sEndTime.required">Select End Time</div>
                  </div>
                </b-col>
                <b-col sm="3">
                  <label class="mr-sm-2" for="sPromoCode">Promo Code </label>
                  <b-input id="sPromoCode" type="text" placeholder="" v-model.trim="sPromoCode"></b-input>
                </b-col>
                <b-col sm="3" class="align-self-end">
                  <b-button id="sBtn" variant="primary" :disabled="$v.sStartTime.$invalid || $v.sEndTime.$invalid || $v.sPromoCode.$invalid" @click="search"><i class="fa fa-search"></i> Search</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Report</h3>
            <div class="float-right">
              <b-button variant="danger" @click="exportCSV">Export CSV</b-button>
            </div>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col sm="12" md="4">
                <b-row>
                  <b-col sm="12"><h4>Total Deposit: {{ format(stats.TotalDeposit, '0,0.00') }}</h4></b-col>
                  <b-col sm="12"><h4>Total Withdraw: {{ format(stats.TotalWithdraw, '0,0.00') }}</h4></b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row>
                  <b-col sm="12"><h4>Total Turnover: {{ format(stats.Turnover, '0,0.00') }}</h4></b-col>
                  <b-col sm="12"><h4>Total NetWin: {{ format(stats.NetWin, '0,0.00') }}</h4></b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row>
                  <b-col sm="12"><h4>Total Signup: {{ format(stats.SignupCount, '0,0.00') }}</h4></b-col>
                </b-row>
              </b-col>
            </b-row>
            <br/>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(TotalDeposit)="data">
                  {{ format(data.item.TotalDeposit, '0,0.00') }}
                </template>
                <template v-slot:cell(TotalWithdraw)="data">
                  {{ format(data.item.TotalWithdraw, '0,0.00') }}
                </template>
                <template v-slot:cell(Turnover)="data">
                  {{ format(data.item.Turnover, '0,0.00') }}
                </template>
                <template v-slot:cell(NetWin)="data">
                  {{ format(data.item.NetWin, '0,0.00') }}
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../../events.js'
import VueNotifications from 'vue-notifications'
import numeral from 'numeral'
const {required, minLength, maxLength} = require('vuelidate/lib/validators')
const moment = require('moment-timezone')

export default {
  name: 'scratchcard-report-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [
        {key: 'ReportingDate', label: 'Reporting Date'},
        {key: 'PromoCode', label: 'Promo Code'},
        {key: 'Description', label: 'Description'},
        {key: 'SignupCount', label: 'Total Signup'},
        {key: 'Turnover', label: 'Turnover'},
        {key: 'NetWin', label: 'NetWin'},
        {key: 'DepositAmount', label: 'Total Deposit'},
        {key: 'WithdrawAmount', label: 'Total Withdraw'}
      ],
      stats: {
        SignupCount: 0,
        Turnover: 0,
        NetWin: 0,
        TotalDeposit: 0,
        TotalWithdraw: 0
      },
      rowCount: 0,
      perPage: 50,
      currentPage: 1,
      sPromoCode: '',
      sStartTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD'),
      sEndTime: moment().tz('Asia/Taipei').format('YYYY-MM-DD')
    }
  },
  validations: {
    sStartTime: { required },
    sEndTime: { required },
    sPromoCode: { minLength: minLength(1), maxLength: maxLength(20) }
  },
  watch: {
    currentPage: function () {
      this.search()
    }
  },
  methods: {
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    getRowCount () {
      return this.rowCount
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `from=${this.sStartTime}&to=${this.sEndTime}&promoCode=${this.sPromoCode}&size=${this.perPage}&page=${this.currentPage}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/promocode?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        this.items = data.records
        this.rowCount = data.rowCount
        this.stats = {
          SignupCount: data.stats.SignupCount,
          TotalDeposit: data.stats.DepositAmount,
          TotalWithdraw: data.stats.WithdrawAmount,
          Turnover: data.stats.Turnover,
          NetWin: data.stats.NetWin
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    async exportCSV () {
      try {
        Events.$emit('loader')
        let queryStr = `from=${this.sStartTime}&to=${this.sEndTime}&promoCode=${this.sPromoCode}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/report/promotion/promocode/export?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        let url = window.URL.createObjectURL(new Blob([ data ]))
        let link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `promo_code_report_${moment(this.sStartTime).format('YYYYMMDD')}_${moment(this.sEndTime).format('YYYYMMDD')}.csv`)
        document.body.appendChild(link)
        link.click()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/report/promotion/promoCode/PromoCodeReportTable.vue